export default "__VITE_ASSET__f3cd5012__"